export default __webpack_public_path__ + "static/media/door.7d4be1e2.svg";